/*
 * Copyright (c) 2022. Dave van Rijn Development
 */

import React from 'react';
import {Testimonial} from './interfaces';

const testimonials: Testimonial[] = [
    {
        name: 'Connie', message: (
            <label className='review'>
                Fantastisch! Door prive omstandigheden kunnen we tijdelijk onze hond niet altijd zelf uitlaten! Maar als
                het straks wel weer kan blijven we toch nog gebruik maken van Bowie's!! Onze hond gaat graag met haar
                mee! Neemt echt de tijd voor lekker wandelen. Droogt de hond zijn poten als ie terug komt.
            </label>
        ), rating: 5
    },
    {
        name: 'Miriam',
        message: <label className='review'>Ik ben erg tevreden. En ik ben blij dat mijn herder hier welkom is. Ik raad
            het iedereen aan. Groetjes Miriam.</label>, rating: 5
    },
    {
        name: 'Bianca',
        message: (
            <label className='review'>Doordat mijn partner en ik geen vaste dagen werken is het fijn dat bowie’s
                hondenuitlaatservice zeer flexibel is. Daarnaast merken wij dat onze honden graag mee gaan. Wij zouden
                iedereen bowie’s aanraden.</label>
        ),
        rating: 5
    },
    {
        name: 'Margit',
        message: (
            <label className='review'>Superblij met Leonique!<br/>Je merkt dat zij haar werk met veel liefde en passie
                doet.<br/>Onze Bliss is altijd erg blij om met haar mee te gaan om lekker te rennen!</label>
        ),
        rating: 5
    },
    {
        name: 'Anouk',
        message: (
            <label className='review'>Wij zijn super blij met Bowie's Hondenuitlaatservice! Onze 1 jarige labrador Pip
                gaat wekelijks mee om gezellig met andere honden in contact te komen. Leonique heeft veel geduld met de
                honden en is goed bereikbaar. Ook maakt ze vaak leuke filmpjes en foto's tijdens de wandelingen. Pip is
                altijd erg voldaan als zij terug komt en wordt elke keer superblij als ze door heeft dat ze weer mee
                mag {'<3'}</label>
        ),
        rating: 5
    },
    {
        name: 'Heike',
        message: (
            <label className='review'>Onze hond gaat wekelijks op pad met Leonique en dat bevalt uitstekend. Op het
                begin vond de hond het spannend, maar Leonique ging daar rustig mee om en nam er de tijd voor. Al snel
                vond onze hond het fantastisch om met Leonique (en de andere honden) op pad te gaan. Leonique is goed
                bereikbaar, flexibel en betrouwbaar. Echt een aanrader voor zowel baas als hond!</label>
        ),
        rating: 5
    },
    {
        name: 'M. van Rooijen',
        message: (
            <label className='review'>Wij zijn heel erg blij met Bowie's uitlaatservice. Leonique gaat professioneel en
                heel erg leuk om met, Buiter, onze hond. We vertrouwen Buiter dan ook 100% aan haar toe.</label>
        ),
        rating: 5
    },
    {
        name: 'Frederieke',
        message: (
            <label className='review'>Leonique is een lieve meid die erg begaan is met de honden. Ze neemt uitgebreid de
                tijd voor een grote wandeling, waarin Moos niks te kort komt. Knuffels, aaien en koekjes zit sowieso in
                het 'pakket' bij een wandeling met Leonique.</label>
        ),
        rating: 5
    },
    {
        name: 'Marit',
        message: (
            <label className='review'>Onze hond kees is zo blij met Leonique. Hij gaat niet graag met de auto maar het
                witte busje van Bowie's springt hij graag in. Wij zijn zelf ook heel blij met haar. In m'n 2e
                zwangerschap lukte lange stukken lopen niet meer zo goed. Toen was het heel fijn om daarin een beetje
                ontlast te worden, inmiddels gaat Kees al 2 jaar mee met Leonique. Als hij niet zo goed gaat met een
                andere hond meld ze dat en proberen we samen een oplossing te vinden voor bijvoorbeeld een andere
                dag.</label>
        ),
        rating: 5
    }
];

export default testimonials;